import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=b96d8cae&scoped=true&"
import script from "./ValidationError.vue?vue&type=script&lang=js&"
export * from "./ValidationError.vue?vue&type=script&lang=js&"
import style0 from "./ValidationError.vue?vue&type=style&index=0&id=b96d8cae&lang=scss&scoped=true&"
import style1 from "./ValidationError.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d8cae",
  null
  
)

/* custom blocks */
import block0 from "./ValidationError.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports